import { Component, h } from "@lukekaalim/act";
import { TheatreState } from "../../hooks/useTheatreState";
import { TheatreData } from "../../hooks/useTheatreController";
import { useLogger } from "@kosmod/kit";
import { useDisposable } from "@kosmod/graphics-3d";
import { MeshBasicMaterial } from "three";

export type ToolRendererProps = {
  state: TheatreState,
}

export const ToolPreview: Component<ToolRendererProps> = ({ state }) => {
  const logger = useLogger('ToolPreview');
  
  const tool = state.tools.getActiveTool();

  if (!tool || !tool.handler.PreviewComponent)
    return null;

  const material = useDisposable(() => {
    return new MeshBasicMaterial({ color: '#95c6e7' })
  })

  return h(tool.handler.PreviewComponent, {
    theatre: state,
    toolState: tool.state,
    cursorPosition: state.cursorPosition,
    material,
  })
};